export default __webpack_public_path__ + "static/media/share.7c652928.svg";